import { render } from "./clinicsidebar.vue?vue&type=template&id=6a479c58"
import script from "./clinicsidebar.vue?vue&type=script&lang=js"
export * from "./clinicsidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__